import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomError } from 'types';
import { getClippPricingData } from 'services/clipp-pricing/getClippPricingData';
import { closeModal, openModal } from './modalReducer';
import { ClippInfo } from 'pco-product-service-internal-consumer';

export type ClippPricingUrls = {
  urls: ClippInfo;
  isLoading?: boolean;
  error?: CustomError;
};

export const initialClipPricingState: ClippPricingUrls = {
  urls: {
    isEligible: false,
    createUrl: '',
  },
};

export const fetchClippPricingUrlData = createAsyncThunk(
  'CLIPP_PRICING/fetchClippPricingUrlData',
  async (partnerNumber: string, thunkAPI) => {
    try {
      const data = await getClippPricingData(partnerNumber);
      thunkAPI.dispatch(setClippPricingUrls({ urls: data }));
      return;
    } catch (err: unknown) {
      thunkAPI.dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            httpError: err,
            okHandler: () => {
              thunkAPI.dispatch(closeModal());
            },
            technicalInfo: {
              title: 'Error when retrieving CLIPP information',
              userErrorMessage: 'An error occurred when retrieving CLIPP information. Please try again later.',
            },
          },
        }),
      );
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const clippPricingUrlsSlice = createSlice({
  name: 'CLIPPRISINGURLS',
  initialState: initialClipPricingState,
  reducers: {
    setClippPricingUrls: (state, action: PayloadAction<ClippPricingUrls>) => {
      return { ...state, ...action.payload };
    },
    setClippPricingUrlsError: (state, action: PayloadAction<CustomError | undefined>) => {
      return { ...state, error: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClippPricingUrlData.pending, (state) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(fetchClippPricingUrlData.rejected, (state, action) => {
      return { ...state, error: action.payload as CustomError };
    });
    builder.addCase(fetchClippPricingUrlData.fulfilled, (state) => {
      return { ...state, isLoading: false };
    });
  },
});

export const { setClippPricingUrls, setClippPricingUrlsError } = clippPricingUrlsSlice.actions;
export default clippPricingUrlsSlice.reducer;
